import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import '../Customers/CustomersStyle.css';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import numberToEnglish from '../Common/CommonMethods';
import Alert from 'react-s-alert';
import moment from 'moment';
import html2canvas from 'html2canvas';
import { ThemeContext } from '../Common/ThemeProvider';
import WaterMark from '../../Images/watermark_mfi.png';
import jsPdf from 'jspdf'
import Select from 'react-select';
import Barcode from 'react-barcode';

const GenerateLR = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [CompanyInfo, setCompanyInfo] = useState({});
    const [LRData, setLRData] = useState({});
    const [LRID, setLRID] = useState([]);
    const [FilterLRData, setFilterLRData] = useState([]);
    const [Total, setTotal] = useState(0);
    const [CustTransCopy, setCustTransCopy] = useState(0);
    const [IBAData, setIBAData] = useState({});
    const [IBALogo, setIBALogo] = useState("");

    const companyLogo = localStorage.getItem("CompanyLogo") != null ? localStorage.getItem("CompanyLogo") : null;
    const OrgData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

    useEffect(() => {
        FetchLR();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchLR = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        var companyInfo = localStorage.getItem("CompanyInfo") ? JSON.parse(localStorage.getItem("CompanyInfo")) : null;
        if (companyInfo !== null) {
            setCompanyInfo(companyInfo);
        }

        Axiosfetch(baseURL + "GetLorryRecieptByOrgID", "POST", { OrgID: userData.OrganizationID }, LRIDsSuccess, Failure);
    };

    const LRIDsSuccess = (data) => {
        if (data.length > 0) {
            var lrData = [];
            setLRID(data);
            data.forEach(lr => {
                lrData.push({ label: lr.JobID, value: lr._id })
            });

            setFilterLRData(lrData);
        }
        else {
            setFilterLRData([]);
        }
    };

    const LRSuccess = (data) => {

        if (data.length > 0) {
            setLRData(data[0]);
            if ((data[0].Survey && data[0].Survey.length > 0 && data[0].Survey[0].IBAApproval === 1) ||
                (data[0].Quotation && data[0].Quotation.length > 0 && data[0].Quotation[0].InstantCustomerIBAApproved === 1)) {
                Axiosfetch(baseURL + "GetActiveIBAData", "GET", null, IBADataSuccess, Failure);
            }

            var total = 0;
            if (data[0].CGST !== 0) {
                let charges = data[0].FreightCharges + data[0].FuelCharges + data[0].OtherCharges;
                total = charges + (charges * ((data[0].CGST + data[0].SGST) / 100));
            }
            else {
                let charges = data[0].FreightCharges + data[0].FuelCharges + data[0].OtherCharges;
                total = charges + (charges * (data[0].IGST / 100));
            }

            setTotal(total);
        }
        else {
            setLRData([]);
        }
    };

    const IBADataSuccess = (data) => {
        if (data.length > 0) {
            setIBAData(data[0]);
            Axiosfetch(baseURL + "GetIBAFile", "POST", { fileName: data[0].IBAFileName }, IBAFileDataSuccess, Failure);
        }
    };

    const IBAFileDataSuccess = (data) => {
        if (data.success) {
            if (data.fileData !== null) {
                setIBALogo(data.fileData);
            }
            else {
                Alert.error("Error fetching IBA Logo", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
        else {
            Alert.error("Error fetching IBA Logo", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnLRChange = (lrDetails) => {
        let lr = lrDetails ? lrDetails.value : "";
        if (lr !== "") {
            let lrfetch = LRID.filter(c => c._id === lr);
            if (lrfetch.length > 0) {
                Axiosfetch(baseURL + "GetLorryRecieptByID", "POST", { _id: lrfetch[0]._id }, LRSuccess, Failure);
            }
        }
        else {
            setLRData([]);
        }
    };

    const printPDF = () => {
        // if (SelectedQuotationPDFInfo > 0 && SelectedInvoice > 0) {
        const domElement = document.getElementById('lrDocument');
        html2canvas(domElement, {
            scale: 1.6
        })
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                var imgWidth = 205;
                var pageHeight = 295;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;
                var doc = new jsPdf('p', 'mm');
                var position = 2;

                doc.setFontSize(10);
                doc.setTextColor(187, 187, 187);
                doc.text("** This is computer generated Document. No signature required **", (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 18, { align: 'center' });

                doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();

                    doc.addImage(imgData, 'PNG', 2, position + 1, imgWidth, imgHeight, '', 'FAST');
                    heightLeft -= pageHeight;

                }

                doc.save('LR' + LRData.JobID + "_" + moment().format("DDMMYYYY") + "_" + (CustTransCopy === 0 ? "CustomerCopy" : "TransportCopy") + '.pdf');
            });
        // }
        // else {
        //     Alert.error("Please Select Invoice.", {
        //         position: 'bottom-right',
        //         effect: 'slide',
        //         html: false
        //     });
        // }
    };

    const OnCheckboxChange = (e) => {
        if (e.target.name === "TransCopy") {
            setCustTransCopy(1);
        }
        else {
            setCustTransCopy(0);
        }

    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row" style={{ marginBottom: "1.5rem" }}>
                    <div className="col-md-3 col-12 align-right responsive-align">
                        <span style={{ verticalAlign: "text-bottom", paddingRight: "10px" }}> Customer Copy</span>
                        <input checked={CustTransCopy === 0} onChange={OnCheckboxChange} name="CustCopy" type="checkbox"></input>
                        <span style={{ paddingLeft: "1.5rem", verticalAlign: "text-bottom", paddingRight: "10px" }}>Transport Copy</span>
                        <input checked={CustTransCopy === 1} onChange={OnCheckboxChange} name="TransCopy" type="checkbox"></input>
                    </div>
                    <div className="col-md-3 col-12 align-right responsive-align">
                        <h5 style={{ fontWeight: "500" }}>LR Document</h5>
                    </div>
                    <div className="col-md-4 col-12" style={{ display: "flex", justifyContent: "flex-end" }}>
                        <div className="dropdownMobile">
                            <Select isClearable={true} isSearchable={true} placeholder="Select LR *"
                                options={FilterLRData}
                                onChange={OnLRChange}></Select>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-2 align-right">
                        {LRData.LoginOrg !== undefined && (<button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={printPDF}>Generate PDF</button>)}
                    </div>
                </div>
                {(LRData.LoginOrg !== undefined && LRData.LoginOrg.length > 0 && LRData.PartnerOrg !== undefined && LRData.PartnerOrg.length > 0) &&
                    (<div className="row" style={{ height: "71vh", overflow: "auto", margin: "0 1.5rem", paddingTop: "5px" }}>
                        <div className="col-md-12 col-sm-12" id="lrDocument">
                            <div className="row" style={{
                                backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "top", margin: "4px",
                                backgroundImage: (OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].LogoApproval && OrgData.Organization[0].LogoApproval === 1) ? "url('" + WaterMark + "')" : "none",
                                padding: "1.5rem 1rem 2rem 1rem"
                            }}>
                                <div className="col-md-6 col-sm-6 responsive-align">
                                    <div style={{ fontSize: "40px", color: "#005582", paddingLeft: "10px", fontWeight: "600" }}>Lorry Reciept</div>
                                    <div className='text-uppercase' style={{ paddingLeft: "10px", color: "gray", fontSize: "13px" }}>
                                        {OrgData && OrgData._id && OrgData._id !== "" && `${OrgData._id}_${moment().format("DDMMYYYY_hhmm")}`}
                                    </div>

                                    {LRData.JobID && (<div>
                                        <Barcode width={1} height={35} displayValue={true}
                                            value={LRData.JobID}></Barcode>
                                    </div>)}
                                </div>
                                <div className="col-md-6 col-12 d-flex">
                                    <div style={{ width: "100%", textAlign: "right" }}>
                                        {LRData.LoginOrg && (<h4> {((LRData.Survey && LRData.Survey.length > 0 && LRData.Survey[0].IBAApproval === 1) ? "Issued By :" : "") + " " + LRData.LoginOrg[0].Name}</h4>)}
                                        {LRData.LoginOrg && (<h6> {LRData.LoginOrg[0].AddressLine1}, {LRData.LoginOrg[0].AddressLine2},
                                            {LRData.LoginOrg[0].City}, {LRData.LoginOrg[0].State}, {LRData.LoginOrg[0].PostalCode}</h6>)}
                                        {LRData.LoginOrg && (<h5>GST : {LRData.LoginOrg[0].GSTNumber}</h5>)}
                                    </div>
                                    <div style={{ width: "50%", textAlign: "center" }}>
                                        <img style={{ width: "9rem", height: "8rem" }} alt="logo" src={(LRData.Survey && LRData.Survey.length > 0 && LRData.Survey[0].IBAApproval === 1) ? (IBALogo === "" ? companyLogo : IBALogo) : companyLogo}></img>
                                    </div>
                                </div>
                                {/* <div className="col-md-2 col-sm-4 align-center" style={{ marginTop: "0.5rem" }}>
                                    <div className="LRDocChkStyle" style={{ border: "1px solid #ccc" }}>
                                        <div style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black", border: "none", marginBottom: "0.5rem", borderBottom: "1px solid #ccc" }}>
                                            JOB ID
                                        </div>
                                        <div>
                                            {LRData.JobID && (<h5> {LRData.JobID}</h5>)}
                                        </div>
                                    </div>
                                </div> */}
                                {LRData.Survey && LRData.Survey.length > 0 && LRData.Survey[0].IBAApproval === 1 && (<div className="col-md-2 col-sm-4 align-center" style={{ marginTop: "0.5rem" }}>
                                    <div className="LRDocChkStyle" style={{ border: "1px solid #ccc" }}>
                                        <div style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black", border: "none", marginBottom: "0.5rem", borderBottom: "1px solid #ccc" }}>
                                            IBA No.
                                        </div>
                                        <div>
                                            {IBAData.IBANumber && (<h5> {IBAData.IBANumber}</h5>)}
                                        </div>
                                    </div>
                                </div>)}
                                <div className={`${(LRData.Survey && LRData.Survey.length > 0 && LRData.Survey[0].IBAApproval === 1) ? "offset-md-8" : "offset-md-10"} col-md-2 col-sm-4 align-center`} style={{ marginTop: "0.5rem" }}>
                                    <div className="LRDocChkStyle" style={{ border: "1px solid #ccc" }}>
                                        <div style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black", border: "none", marginBottom: "0.5rem", borderBottom: "1px solid #ccc" }}>
                                            Date
                                        </div>
                                        <div>
                                            {LRData.JobID && (<h5> {moment(LRData.createdAt).local().format("DD.MM.YYYY")}</h5>)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-sm-6 align-center" style={{ marginTop: "1rem" }}>
                                    <div className="LRDocChkStyle" style={{ border: "1px solid #ccc" }}>
                                        <div style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black", border: "none", marginBottom: "0.5rem", padding: "1rem", borderBottom: "1px solid #ccc" }}>
                                            Consignor Name / Address
                                        </div>
                                        <div>
                                            <h4> {(LRData.Survey && LRData.Survey.length > 0) ? LRData.Survey[0].Name : (LRData.Quotation && LRData.Quotation.length > 0) ? LRData.Quotation[0].InstantCustomerName : ""}</h4>
                                            {(LRData.Survey && LRData.Survey.length > 0) ? (<h6> {LRData.Survey[0].OriginAddress},
                                                {LRData.Survey[0].OriginCity}, {LRData.Survey[0].OriginState}, {LRData.Survey[0].OriginPincode}, {LRData.Survey[0].OriginCountry}</h6>) :
                                                (LRData.Quotation && LRData.Quotation.length > 0) ? (<h6> {LRData.Quotation[0].InstantCustomerOriginCity},
                                                    {LRData.Quotation[0].InstantCustomerOriginPincode}</h6>) : ""}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-sm-6 align-center" style={{ marginTop: "1rem" }}>
                                    <div className="LRDocChkStyle" style={{ border: "1px solid #ccc" }}>
                                        <div style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black", border: "none", marginBottom: "0.5rem", padding: "1rem", borderBottom: "1px solid #ccc" }}>
                                            Consignee Name / Address
                                        </div>
                                        <div>
                                            <h4> {(LRData.Survey && LRData.Survey.length > 0) ? LRData.Survey[0].Name : (LRData.Quotation && LRData.Quotation.length > 0 ? LRData.Quotation[0].InstantCustomerName : "")}</h4>
                                            {(LRData.Survey && LRData.Survey.length > 0) ? (<h6> {LRData.Survey[0].DestinationAddress},
                                                {LRData.Survey[0].DestinationCity}, {LRData.Survey[0].DestinationState}, {LRData.Survey[0].DestinationPincode}, {LRData.Survey[0].DestinationCountry}</h6>) :
                                                (LRData.Quotation && LRData.Quotation.length > 0) ? (<h6> {LRData.Quotation[0].InstantCustomerDestCity},
                                                    {LRData.Quotation[0].InstantCustomerDestPincode}</h6>) : ""}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-sm-12 align-center" style={{ marginTop: "1rem" }}>
                                    <table className="table table-bordered">
                                        <thead style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black" }}>
                                            <tr>
                                                <th style={{ position: "unset" }}>Delivery Branch Name / Address</th>
                                                <th style={{ position: "unset" }}>Contact Number</th>
                                                <th style={{ position: "unset" }}>Fright</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "45%" }}>
                                                    {LRData.PartnerOrg && (<h4> {`MFI ${LRData.PartnerOrg[0].City}`}</h4>)}
                                                    {LRData.PartnerOrg && (<h6> {LRData.PartnerOrg[0].AddressLine1}, {LRData.PartnerOrg[0].AddressLine2},
                                                        {LRData.PartnerOrg[0].City}, {LRData.PartnerOrg[0].State}, {LRData.PartnerOrg[0].PostalCode}, {LRData.PartnerOrg[0].Country}</h6>)}
                                                </td>
                                                <td>
                                                    {LRData.PartnerOrg && (<h2> {LRData.PartnerOrg[0].Contact}</h2>)}
                                                </td>
                                                <td>
                                                    <table className="table align-center">
                                                        <tbody>
                                                            <tr>
                                                                <td>Moving From : <h4>{(LRData.Survey && LRData.Survey.length > 0) ? LRData.Survey[0].OriginCity :
                                                                    (LRData.Quotation && LRData.Quotation.length > 0 ? LRData.Quotation[0].InstantCustomerOriginCity : "")}</h4></td>
                                                                <td>Moving To : <h4>{(LRData.Survey && LRData.Survey.length > 0) ? LRData.Survey[0].DestinationCity :
                                                                    (LRData.Quotation && LRData.Quotation.length > 0 ? LRData.Quotation[0].InstantCustomerDestCity : "")}</h4></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-12 col-sm-12 align-center" style={{ marginTop: "1.5rem" }}>
                                    <table className="table table-bordered">
                                        <thead style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black" }}>
                                            <tr>
                                                <th style={{ position: "unset", wordBreak: "break-word" }}>Truck No.</th>
                                                <th style={{ width: "25%", position: "unset", wordBreak: "break-word" }}>No. of Packages</th>
                                                <th style={{ width: "35%", position: "unset", wordBreak: "break-word" }}>Goods Description</th>
                                                <th style={{ position: "unset" }}>Weight</th>
                                                <th style={{ position: "unset" }}>Tentative Delivery Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{LRData !== null && <div>{LRData.TruckNumber}</div>}</td>
                                                <td>{LRData !== null && <div>{LRData.Packages}</div>}</td>
                                                <td>{LRData !== null && <div>{LRData.Description} </div>}</td>
                                                <td>{LRData !== null && LRData.ActualWeight} KG</td>
                                                <td>{LRData.Survey && LRData.Survey.length > 0 ? moment(LRData.Survey[0].PreferredDeliveryDate).local().format("DD.MM.YYYY") :
                                                    (LRData.Quotation && LRData.Quotation.length > 0 && LRData.Quotation[0].IsInstant === 1 && LRData.TentativeDeliveryDate !== null ?
                                                        moment(LRData.TentativeDeliveryDate).local().format("DD/MM/YYYY") : "-")}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {(CustTransCopy === 0 && LRData.Payment !== 3) && (<div className="col-md-12 col-sm-12 align-center" style={{ marginTop: "1.5rem" }}>
                                    <table className="table table-bordered">
                                        <thead style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black" }}>
                                            <tr>
                                                <th style={{ position: "unset" }}>Freight Charges</th>
                                                <th style={{ position: "unset" }}>Fuel Surcharge</th>
                                                <th style={{ position: "unset" }}>Other Charges</th>
                                                {LRData.CGST > 0 && <th style={{ position: "unset" }}>CGST</th>}
                                                {LRData.CGST > 0 && <th style={{ position: "unset" }}>SGST</th>}
                                                {LRData.IGST > 0 && <th style={{ position: "unset" }}>IGST</th>}
                                                <th style={{ position: "unset" }}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                                <td>{LRData !== null && (<span>{LRData.FreightCharges}</span>)}</td>
                                                <td>{LRData !== null && (<span>{LRData.FuelCharges}</span>)}</td>
                                                <td>{LRData !== null && (<span>{LRData.OtherCharges}</span>)}</td>
                                                {LRData.CGST > 0 && (<td>{<span>{LRData.CGST} %</span>}</td>)}
                                                {LRData.SGST > 0 && (<td>{<span>{LRData.SGST} %</span>}</td>)}
                                                {LRData.IGST > 0 && (<td>{<span>{LRData.IGST} %</span>}</td>)}
                                                <td><span>{Total}</span></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5"> Amount (in words)  : <b><span style={{ textTransform: "uppercase" }}>
                                                    {numberToEnglish(Total)}
                                                </span></b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>)}
                                {LRData.PaidBy > 0 && (<div className="col-md-6 col-sm-6 align-center" style={{ marginTop: "1.5rem" }}>
                                    <h5>GSTIN Paid By</h5>
                                    <table className="table table-striped">
                                        <tbody>
                                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                                <td><span style={{ paddingRight: "20px" }}>Consignor</span>{LRData.PaidBy === 1 && (<input style={{ transform: "scale(1.3)" }} type="checkbox" checked={true}></input>)}</td>
                                                <td><span style={{ paddingRight: "20px" }}>Consignee</span>{LRData.PaidBy === 2 && (<input style={{ transform: "scale(1.3)" }} type="checkbox" checked={true}></input>)}</td>
                                                <td><span style={{ paddingRight: "20px" }}>Transnsporter</span>{LRData.PaidBy === 3 && (<input style={{ transform: "scale(1.3)" }} type="checkbox" checked={true}></input>)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>)}
                                <div className={`${LRData.PaidBy > 0 ? "col-md-6 col-sm-6 col-12" : "col-md-12 col-12"} align-center`} style={{ marginTop: "1.5rem" }}>
                                    <h5>Payment</h5>
                                    <table className="table table-striped">
                                        <tbody>
                                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                                <td><span style={{ paddingRight: "20px" }}>Paid</span>{LRData.Payment === 1 && (<input style={{ transform: "scale(1.3)" }} type="checkbox" checked={true}></input>)}</td>
                                                <td><span style={{ paddingRight: "20px" }}>To pay</span>{LRData.Payment === 2 && (<input style={{ transform: "scale(1.3)" }} type="checkbox" checked={true}></input>)}</td>
                                                <td><span style={{ paddingRight: "20px" }}>To be Billed</span>{LRData.Payment === 3 && (<input style={{ transform: "scale(1.3)" }} type="checkbox" checked={true}></input>)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {(LRData.DeliveryNote !== undefined && LRData.DeliveryNote !== "") && (<div className="col-md-12 col-sm-12 align-center" style={{ marginTop: "1rem" }}>
                                    <table className="table table-bordered">
                                        <thead style={{ backgroundColor: "rgba(0,0,0,.05)", color: "black" }}>
                                            <tr>
                                                <th style={{ position: "unset" }}>Delivery Note</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {LRData.DeliveryNote}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>)}
                                <div className="col-md-6 col-sm-6" style={{ marginTop: "1.5rem" }}>
                                    <div className="align-right title">
                                        <div style={{ paddingBottom: "80px" }}>
                                        </div>
                                        <h6 className="align-left"><b>Owner or Authorized Agent</b></h6>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6" style={{ marginTop: "1.5rem" }}>
                                    <div className="align-right title">
                                        <div style={{ paddingBottom: "80px" }}>
                                        </div>
                                        <h6 className="align-right"><b>Contractor Carrier or Transporter Signature</b></h6>
                                    </div>
                                </div>
                                {CompanyInfo.LRTerms !== null && CompanyInfo.LRTerms !== undefined && (<div className="col-md-12 col-sm-12">
                                    <hr></hr>
                                    <div>
                                        <h5>Terms and Conditions</h5>
                                    </div>
                                    <ol>
                                        {((LRData.Survey.length > 0 && LRData.Survey[0].IBAApproval === 0) || (
                                            LRData.Quotation && LRData.Quotation.length > 0 && LRData.Quotation[0].InstantCustomerIBAApproved === 0))
                                            && CompanyInfo.LRTerms.split('|').map((terms, index) => (
                                                <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                                </li>
                                            ))}
                                        {((LRData.Survey.length > 0 && LRData.Survey[0].IBAApproval === 1) || (
                                            LRData.Quotation && LRData.Quotation.length > 0 && LRData.Quotation[0].InstantCustomerIBAApproved === 1))
                                            && IBAData.IBATerms && IBAData.IBATerms.split('|').map((terms, index) => (
                                                <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                                </li>
                                            ))}
                                    </ol>
                                </div>)}
                            </div>
                        </div>
                    </div>)}
            </div>
        </div>
    );
};

export default GenerateLR;